<template>
  <div>
    <Loading
      :show="isScreenLoading"
    />
    <div class="contents-ttl container-xl">
      <Breadcrumb v-if="crumbs.length" :crumbs="crumbs" />

      <div class="main-ttl container-xl">
        <div class="flex">
          <div class="thumb-round thumb-device">
          <img
            v-if="screenItems?.monitoringTarget?.getImageFileUrl() !== ''"
            alt="デバイスのサムネイル"
            :src="screenItems?.monitoringTarget?.getImageFileUrl()"
          />
          </div>
          <h2 class="main-txt">
            {{ screenItems.monitoringTarget?.name }}
            <span class="sub-txt mt-2">{{ screenItems.monitoringTarget?.monitoringTargetId }}</span>
          </h2>
        </div>

        <div class="btn-area">
          <Button
            variant="sub"
            small
            :icon="icons.SettingIcon"
            alt="設定アイコン"
            @click.stop="detail"
          >
            設定変更
          </Button>
        </div>
      </div>
    </div>

    <main class="container-xl">
      <div class="card-area">
        <section
          class="card card-device"
          :class="{
            stop: screenItems.monitoringTargetStatus === 'not_monitored'
              || screenItems.monitoringTargetStatus === 'not_ready' ,
            caution: screenItems.monitoringTargetStatus === 'caution',
            warning: screenItems.monitoringTargetStatus === 'warning',
          }"
        >
          <div class="flex device-detail">
            <div class="form-check-inline form-switch">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="formData.monitoringStatus"
                @change="changeMonitoringStatus"
                :disabled="!isScreenActive"
              />
              <label
                v-if="formData.monitoringStatus === false"
                class="form-switch-label"
                for="form-switch-01"
              > 停止中</label>
              <label
                v-else-if="screenItems.monitoringTargetStatus === 'warning'"
                class="form-switch-label"
                for="form-switch-01"
              > アラート発生中</label>
              <label
                v-else
                class="form-switch-label"
                for="form-switch-01"
              > 監視中</label>
            </div>
            <div v-if="screenItems.monitoringTargetStatus === 'not_monitored'" class="device-msg">
              <div class="msg-bar">設備の監視を停止しました</div>
            </div>
            <div v-else-if="screenItems.monitoringTargetStatus === 'not_ready'" class="device-msg">
              <div class="msg-bar">まだ登録が完了していません</div>
            </div>
            <div v-else-if="screenItems.monitoringTargetStatus === 'warning'" class="device-msg">
              <div class="msg-bar">
                {{ screenItems.notificationTitle }}
              </div>
              <span class="date">
                {{ screenItems.notificationTimestamp }}
              </span>
            </div>
            <div v-else-if="screenItems.monitoringTargetStatus === 'caution'" class="device-msg">
              <div class="msg-bar">
                {{ screenItems.notificationTitle }}
              </div>
              <span class="date">
                {{ screenItems.notificationTimestamp }}
              </span>
            </div>

            <div class="device-status flex ps-auto">
              <div class="antenna">
                <img v-if="screenItems.networkStatus === 'excellent'"
                  src="@/assets/img/ico_antenna_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
                <img v-else-if="screenItems.networkStatus === 'good'"
                  src="@/assets/img/ico_antenna_02.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
                <img v-else-if="screenItems.networkStatus === 'not_good'"
                  src="@/assets/img/ico_antenna_01.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
                <img v-else
                  src="@/assets/img/ico_antenna_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
                <span>{{ screenItems.networkStatusLabel }}
                </span>
              </div>
              <div class="battery">
                <img v-if="screenItems.batteryStatus === 'high'"
                  src="@/assets/img/ico_battery_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
                <img v-else-if="screenItems.batteryStatus === 'mid'"
                  src="@/assets/img/ico_battery_02.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
                <img v-else-if="screenItems.batteryStatus === 'low'"
                  src="@/assets/img/ico_battery_01.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
                <img v-else
                  src="@/assets/img/ico_battery_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
                <span>{{ screenItems.batteryStatusLabel }}
                </span>
              </div>
            </div>
          </div>

          <div class="row device-info">
            <dl class="col-md-6">
              <div>
                <dt>監視デバイス：</dt>
                <dd>
                  <img
                    src="@/assets/icons/ico_arrow.png"
                    alt="遷移アイコン"
                    class="ico-base ico-xs"
                    style="transform: rotate(-90deg)"
                  />
                  <span v-if="screenItems.monitoringDevice === null">
                  -</span>
                  <span v-else-if="!screenItems.monitoringDevice.name">
                    AS-CMU
                    ({{ screenItems.monitoringDevice.productKey }})
                  </span>
                  <span v-else>
                    {{ screenItems.monitoringDevice.name }}
                    （{{ screenItems.monitoringDevice.productKey }}）
                  </span>
                </dd>
              </div>
              <div class="mt-2">
                <dt>利用可能期間：</dt>
                <dd v-if="screenItems.ascmuSubscription === null">
                -</dd>
                <dd v-else-if="screenItems.ascmuSubscription.isAutoRenewalActive()">
                  <span>自動更新 : {{ screenItems.ascmuSubscription.paymentCycleText() }}</span>
                  <span>（次回更新日 :
                    <span>{{ screenItems.ascmuSubscription.expiresAtText() }}</span>
                  ）</span>
                </dd>
                <dd v-else-if="screenItems.ascmuSubscription.isActive()">
                  <span>{{ screenItems.ascmuSubscription.expiresAtText() }} まで</span>
                </dd>
                <dd v-else>
                  契約なし
                </dd>
              </div>
            </dl>
            <dl class="col-md-6 flex-r-item">
              <div>
                <dt>アラート条件：</dt>
                <dd v-if="screenItems.contactMonitoringEventRule === null"
                >-</dd>
                <dd
                  v-else
                >{{ screenItems.contactMonitoringEventRule.contactTypeText() }}</dd>
              </div>
            </dl>
          </div>
        </section>

        <section class="card card-facility">
          <h3>監視設備について</h3>
          <div>
            <p class="pt-1">備考欄</p>
            <template  v-if="screenItems.monitoringTarget === null">
            -</template>
            <template  v-else>
            <p class="mb-0 textarea-wrap" v-html="autoLink(screenItems.monitoringTarget.note)"></p>
            </template>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<style scoped>
/* これを設定 */
.textarea-wrap {
  white-space: pre-wrap;
}
</style>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "repositories/factory";
import { Button, Breadcrumb2 as Breadcrumb, Loading } from "components";

import { SettingIcon } from "icons";
import { SampleImage6 } from "img";

import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";
import { MONITORING_STATUS_CD } from "models/monitoring-target";

const MonitoringTargetsRepository = RepositoryFactory.get("monitoring-targets");
const MonitoringDevicesRepository = RepositoryFactory.get("monitoring-devices");
const AscmuMonitoringSettingsRepository = RepositoryFactory.get("ascmu-monitoring-settings");
const ContactMonitoringEventRulesRepository = RepositoryFactory.get("contact-monitoring-event-rules");
const MabeeemlMonitoringDevicesRepository = RepositoryFactory.get("mabeeeml-monitoring-devices");

export default {
  name: "MonitoringTargets",
  components: {
    Button,
    Breadcrumb,
    Loading,
  },
  data() {
    return {
      headingTitle: "監視対象",
      headingDesc: "監視対象ごとの現在の状態を一覧表示します。",
      crumbs: [
        {
          label: "監視対象",
          routeName: "MonitoringTargetsList",
        },
        {
          label: "監視対象情報",
          routeName: null,
        },
      ],
      icons: {
        SettingIcon,
      },
      img: {
        SampleImage6,
      },
      id: null,
      htmlNote: "",
      paymentCycle: "",
      // Screen Data
      screenItems: {
        monitoringTargetStatus: null,
        monitoringTarget: null,
        ascmuMonitoringSetting: null,
        monitoringDevice: null,
        // 監視対象ステータス
        batteryStatus: null,
        batteryStatusLabel: "-",
        networkStatus: null,
        networkStatusLabel: "-",
        deviceStatus: null,
        // 監視設定
        monitoringSetting: null,
        contactMonitoringEventRule: null,
        // サブスクリプション
        ascmuSubscription: null,
        // 通知情報
        notificationTitle: null,
        notificationTimestamp: null,
        latestLogTimestamp: null,
      },
      formData: {
        monitoringStatus: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      userAccount: "profile/userAccount",
      // service-account
      serviceAccountList: "service-account/serviceAccountList",
      currentServiceAccount: "service-account/currentServiceAccount",
      isScreenActive: "application/isScreenActive",
      isScreenLoading: "application/isScreenLoading",
      // asig-project
      asigProjectList: "asig-project/asigProjectList",
      currentAsigProject: "asig-project/currentAsigProject",
    }),
  },
  async created() {
    try {
      // パラメータの取得
      const monitoringTargetId = this.$route.params.id;

      // 画面更新
      await this.updateScreenItems(
        this.currentAsigProject.asigProjectId,
        monitoringTargetId,
      );
    } catch (err) {
      console.log(err);
      // TODO: 発生したエラーを画面に反映
      this.setErrorNotification({
        message: "予期せぬエラーが発生しました。",
      });
    }
    await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
  },
  methods: {
    ...mapActions({
      // app
      updateScreenStatusCd: "application/updateScreenStatusCd",
      // notification
      resetNotificaton: "notification/resetState",
      setErrorNotification: "notification/setErrorNotification",
    }),
    // screenItemsの更新
    async updateScreenItems(projectId, monitoringTargetId) {
      // 初期化
      this.screenItems.monitoringTarget = null;
      this.screenItems.ascmuMonitoringSetting = null;
      this.screenItems.monitoringDevice = null;
      this.screenItems.contactMonitoringEventRule = null;
      this.screenItems.ascmuSubscription = null;

      // 初期化
      // 監視対象
      this.screenItems.monitoringTarget
        = await MonitoringTargetsRepository.get(projectId, monitoringTargetId);
      // 監視設定
      const ascmuMonitoringSettings
        = await AscmuMonitoringSettingsRepository.index(monitoringTargetId);
      if (ascmuMonitoringSettings.length > 0) {
        [this.screenItems.ascmuMonitoringSetting] = ascmuMonitoringSettings;

        // 監視デバイスの情報を取得
        this.screenItems.monitoringDevice = await MabeeemlMonitoringDevicesRepository.get(
          this.screenItems.ascmuMonitoringSetting.projectId,
          this.screenItems.ascmuMonitoringSetting.monitoringDeviceId,
        );

        // 監視デバイスの状態を取得
        const monitoringDeviceStatus = await MabeeemlMonitoringDevicesRepository.getStatus(
          this.screenItems.ascmuMonitoringSetting.projectId,
          this.screenItems.ascmuMonitoringSetting.monitoringDeviceId,
        );
        this.screenItems.batteryStatus
          = monitoringDeviceStatus.batteryStatus;
        this.screenItems.batteryStatusLabel
          = monitoringDeviceStatus.batteryStatusLabel;
        if (this.screenItems.batteryStatus === "unknown") {
          this.screenItems.batteryStatusLabel = "-";
        }

        this.screenItems.networkStatus
          = monitoringDeviceStatus.networkStatus;
        this.screenItems.networkStatusLabel
          = monitoringDeviceStatus.networkStatusLabel;
        if (this.screenItems.networkStatus === "unknown") {
          this.screenItems.networkStatusLabel = "-";
        }

        this.screenItems.deviceStatus = monitoringDeviceStatus.deviceStatus;
        if (monitoringDeviceStatus.latestLogTimestamp) {
          this.screenItems.latestLogTimestamp = moment(
            monitoringDeviceStatus.latestLogTimestamp,
          ).format("YYYY/MM/DD HH:mm");
        } else if (moment().diff(moment(this.screenItems.ascmuMonitoringSetting.createdAt), "hours") < 24) {
          this.screenItems.deviceStatus = "active";
        }
      }
      // 監視設定なし
      if (!this.screenItems.ascmuMonitoringSetting) {
        this.screenItems.monitoringTargetStatus = "not_ready";
      } else if (this.screenItems.monitoringTarget.monitoringStatusCd === "0") {
        this.screenItems.monitoringTargetStatus = "not_monitored";
      } else if (
        this.screenItems.ascmuMonitoringSetting
        && this.screenItems.ascmuMonitoringSetting.monitoringEventStatus.contactEvent === "start"
      ) {
        this.screenItems.monitoringTargetStatus = "warning";
        this.screenItems.notificationTimestamp = moment(
          this.screenItems.ascmuMonitoringSetting.monitoringEventStatus.timestampMsec,
        ).format("YYYY/MM/DD HH:mm");
        this.screenItems.notificationTitle = "アラート条件を検知しました。";
        if (this.screenItems.ascmuMonitoringSetting.monitoringEventStatus.notificationTitle) {
          this.screenItems.notificationTitle
            = this.screenItems.ascmuMonitoringSetting.monitoringEventStatus.notificationTitle;
        }
      } else if (this.screenItems.deviceStatus === "inactive") {
        this.screenItems.monitoringTargetStatus = "warning";
        this.screenItems.notificationTitle = "24時間状態が確認できません";
        this.screenItems.notificationTimestamp = this.latestLogTimestamp;
      } else if (this.screenItems.batteryStatus === "low") {
        this.screenItems.monitoringTargetStatus = "caution";
        this.screenItems.notificationTitle = "電池残量が少なくなっています";
        this.screenItems.notificationTimestamp = this.latestLogTimestamp;
      } else {
        this.screenItems.monitoringTargetStatus = "normal";
      }

      // 接点監視イベント設定
      const contactMonitoringEventRules = await ContactMonitoringEventRulesRepository.index(
        monitoringTargetId,
      );
      if (contactMonitoringEventRules.length > 0) {
        [this.screenItems.contactMonitoringEventRule] = contactMonitoringEventRules;
      }

      // サブスクリプションの指定
      if (this.screenItems.monitoringDevice !== null) {
        console.log(this.screenItems.monitoringDevice);
        const ascmuSubscriptionHistory
          = await MonitoringDevicesRepository.getAscmuSubscriptionHistory(
            this.screenItems.monitoringDevice.projectId,
            this.screenItems.monitoringDevice.monitoringDeviceId,
          );
        if (ascmuSubscriptionHistory.length > 0) {
          [this.screenItems.ascmuSubscription] = ascmuSubscriptionHistory;
        }
      }

      // 監視対象の状態更新
      if (this.screenItems.monitoringTarget.monitoringStatusCd !== MONITORING_STATUS_CD.ON) {
        this.formData.monitoringStatus = false;
      } else {
        this.formData.monitoringStatus = true;
      }
    },
    detail() {
      this.$router.push({
        name: "MonitoringTargetsUpdate",
        params: {
          id: this.$route.params.id,
        },
      });
    },
    async changeMonitoringStatus() {
      try {
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.LOADING);
        await this.resetNotificaton();

        if (this.formData.monitoringStatus === false) {
          this.screenItems.monitoringTarget.monitoringStatusCd = MONITORING_STATUS_CD.OFF;
          if (!this.screenItems.ascmuMonitoringSetting) {
            this.screenItems.monitoringTargetStatus = "not_ready";
          } else {
            this.screenItems.monitoringTargetStatus = "not_monitored";
          }
        } else {
          this.screenItems.monitoringTarget.monitoringStatusCd = MONITORING_STATUS_CD.ON;

          if (!this.screenItems.ascmuMonitoringSetting) {
            this.screenItems.monitoringTargetStatus = "not_ready";
          } else if (
            this.screenItems.ascmuMonitoringSetting
            && this.screenItems.ascmuMonitoringSetting.monitoringEventStatus.contactEvent === "start"
          ) {
            this.screenItems.monitoringTargetStatus = "warning";
            this.screenItems.notificationTimestamp = moment(
              this.screenItems.ascmuMonitoringSetting.monitoringEventStatus.timestampMsec,
            ).format("YYYY/MM/DD HH:mm");
            this.screenItems.notificationTitle = "アラート条件を検知しました。";
            if (this.screenItems.ascmuMonitoringSetting.monitoringEventStatus.notificationTitle) {
              this.screenItems.notificationTitle
                = this.screenItems.ascmuMonitoringSetting.monitoringEventStatus.notificationTitle;
            }
          } else if (this.screenItems.deviceStatus === "inactive") {
            this.screenItems.monitoringTargetStatus = "warning";
            this.screenItems.notificationTitle = "24時間状態が確認できません";
            this.screenItems.notificationTimestamp = this.latestLogTimestamp;
          } else if (this.screenItems.batteryStatus === "low") {
            this.screenItems.monitoringTargetStatus = "caution";
            this.screenItems.notificationTitle = "電池残量が少なくなっています";
            this.screenItems.notificationTimestamp = this.latestLogTimestamp;
          } else {
            this.screenItems.monitoringTargetStatus = "normal";
          }
        }
        this.screenItems.monitoringTarget
          = await MonitoringTargetsRepository.updateMonitoringStatus(
            this.screenItems.monitoringTarget,
          );

        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      } catch (err) {
        console.log(err);
        // TODO: 発生したエラーを画面に反映
        this.setErrorNotification({
          message: "監視ステータスの更新に失敗しました。",
        });
        this.formData.monitoringStatus = !this.formData.monitoringStatus;
        if (this.screenItems.monitoringTarget.monitoringStatusCd === MONITORING_STATUS_CD.OFF) {
          this.screenItems.monitoringTarget.monitoringStatusCd = MONITORING_STATUS_CD.ON;
        } else {
          this.screenItems.monitoringTarget.monitoringStatusCd = MONITORING_STATUS_CD.OFF;
        }

        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
    autoLink(text) {
      if (text) {
        return text.replace(/(https?:\/\/[^\s]*)/g, "<a class='link-blue' target='_blank' href='$1'>$1</a>");
      }
      return "";
    },
  },
};
</script>
